import { render } from "./AddNewBuilding.vue?vue&type=template&id=966a6822"
import script from "./AddNewBuilding.vue?vue&type=script&lang=js"
export * from "./AddNewBuilding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__